/**
 * Copyright Highway9 Networks Inc.
 */
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { cacertConfigService } from "~/services";
import { CACertificate } from "~/types/CACertificate";

// Define the state type for the slice
interface CaCertState {
  loading: boolean;
  data: CACertificate[];
  current: CACertificate | null;
  open: boolean;
}

// Initial state
const initialState: CaCertState = {
  loading: true,
  data: [],
  current: null,
  open: false,
};

// Async thunks for API calls
export const fetchCACertConfigs = createAsyncThunk(
  "cacertConfig/fetchCACertConfigs",
  async () => {
    try {
      const data = await cacertConfigService.getCACertConfigData();
      return data;
    } catch (error) {
      console.error("Error fetching access config data:", error);
      throw error;
    }
  }
);


// Create the slice
const caCertSlice = createSlice({
  name: "caCert",
  initialState,
  reducers: {
    setSelectedConfig: (state, action: PayloadAction<CACertificate | null>) => {
      state.current = action.payload;
    },
    setDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCACertConfigs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
  },
});

// Export actions
export const caCertActions = caCertSlice.actions;

// Export selectors
export const caCertData = (state: RootState) => state.caCert.data;
export const caCertState = (state: RootState) => state.caCert.current;
export const caCertLoading = (state: RootState) => state.caCert.loading;
export const caCertOpen = (state: RootState) => state.caCert.open;


// Export reducer
export default caCertSlice.reducer;
